import { gql } from "@apollo/client";

export const DISMISS_ALL_NOTIFICATIONS = gql`
  mutation DismissAllNotifications {
    dismissAllNotifications
  }
`;
